import _ from 'lodash';

const shuffleArray = (array) => {
  let i = array.length - 1;
  for (; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
};
const clearUrl = (url) =>
  url
    .toLowerCase()
    .trim()
    .replace(/[^A-Za-z0-9]+/gi, '-');

const validateYouTubeUrl = (urlToParse) => {
  if (urlToParse) {
    const regExp = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
    if (urlToParse.match(regExp)) {
      return true;
    }
  }
  return false;
};
const youtubeParser = (url) => {
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = url.match(regExp);
  return match && match[7].length === 11 ? match[7] : false;
};
const checkImageUrl = (url) => {
  return url.match(/\.(jpeg|jpg|gif|png)$/) != null;
};

function clearSelection() {
  if (typeof window !== 'undefined') {
    if (window.getSelection) {
      window.getSelection().removeAllRanges();
    } else if (document.selection) {
      document.selection.empty();
    }
  }
}

function copyToClipboard(containerid) {
  if (typeof window !== 'undefined') {
    clearSelection();
    if (document.selection) {
      const range = document.body.createTextRange();
      range.moveToElementText(document.getElementById(containerid));
      range.select().createTextRange();
      document.execCommand('copy');
    } else if (window.getSelection) {
      const range = document.createRange();
      range.selectNode(document.getElementById(containerid));
      window.getSelection().addRange(range);
      document.execCommand('copy');
      clearSelection();
    }
  }
}

const converContentfulRawToStringArray = (data) => {
  let newData = [];
  if (data.content && data.content.length) {
    for (let i = 0; i < data.content.length; i++) {
      if (data.content[i].content && data.content[i].content.length) {
        newData = [
          ...newData,
          ...converContentfulRawToStringArray(data.content[i]),
        ];
      } else if (data.content[i].value) {
        newData.push(data.content[i].value);
      }
    }
  }
  return newData;
};

const createContentQueries = (raw_data) => {
  const data = JSON.parse(raw_data);
  const newData = converContentfulRawToStringArray(data);
  return newData.join('. ');
};

const generateRandomNumber = () =>
  Math.floor(Math.random() * Date.now())
    .toString()
    .slice(0, 5);

const getListTags = (tagsData) => {
  if (!tagsData.edges.length) return false;
  return tagsData.edges.map(({ node }) => node.tags).flat(Infinity);
};

const getDistincTags = (tagsData) => {
  const listTags = getListTags(tagsData);
  const dictTagsUnique = {};
  listTags.forEach((tag) => {
    if (!dictTagsUnique[tag.trim()]) {
      dictTagsUnique[tag.trim()] = true;
    }
  });
  return Object.keys(dictTagsUnique);
};

const getScrollbarHeight = () =>
  typeof window !== 'undefined'
    ? window.innerHeight * (window.innerHeight / document.body.offsetHeight)
    : 0;

const getDeviceType = () => {
  if (typeof window !== 'undefined') {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua))
      return 'tablet';

    if (
      /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
        ua
      )
    )
      return 'mobile';
    return 'desktop';
  }
  return 'mobile';
};

const joinDateToNumberString = (date = new Date()) => {
  date = new Date(date);
  const getDate = date.getDate();
  const getMonth = date.getMonth() + 1;
  const getYear = date.getFullYear();
  return `${getDate.toString().padStart(2, 0)}${getMonth
    .toString()
    .padStart(2, 0)}${getYear.toString()}`;
};

/**
 * @param {array} posts Array os posts
 * @description return dict of posts sorted by year, month and date
 *
 * @returns {object} sortedPost
 */
const sortingPostsByDate = (posts) => {
  let sortedPosts = {};
  const setPostsIndex = posts.map((post) => ({
    ...post,
    postYear: new Date(post.createdAt).getFullYear(),
    postMonth: new Date(post.createdAt).getMonth() + 1,
    postDate: new Date(post.createdAt).getDate(),
  }));
  const sortedPostsIndex = _.sortBy(
    setPostsIndex,
    ['postYear', 'postMonth', 'postDate'],
    ['asc', 'asc', 'asc']
  );
  sortedPostsIndex.forEach((post) => {
    const { postYear, postMonth } = post;
    if (!sortedPosts[postYear]) {
      sortedPosts[postYear] = {
        [postMonth]: [{ ...post }],
      };
    } else if (!sortedPosts[postYear][postMonth]) {
      sortedPosts[postYear][postMonth] = [{ ...post }];
    } else {
      sortedPosts[postYear][postMonth] = [
        ...sortedPosts[postYear][postMonth],
        { ...post },
      ];
    }
  });
  return sortedPosts;
};

const getMenuNavsListByLocation = (navsGroups, location) => {
  if (Array.isArray(navsGroups) && navsGroups?.length) {
    switch (location) {
      case 'home': {
        let navsListFromHomePage = [];
        navsGroups.forEach((group) => {
          const { nodes } = group;
          navsListFromHomePage = [
            ...navsListFromHomePage,
            {
              totalCount: nodes.length,
              name: group.nodes[0].category,
              path: `/${group.nodes[0].category}`,
            },
          ];
        });
        return navsListFromHomePage;
      }
      case 'category': {
        let navsListFromCategory = [];
        navsGroups.forEach((group) => {
          const { nodes } = group;
          navsListFromCategory = [
            ...navsListFromCategory,
            {
              totalCount: nodes.length,
              name: group.nodes[0].first_child_category,
              path: `/${clearUrl(group.nodes[0].category)}/${clearUrl(
                group.nodes[0].first_child_category
              )}`,
            },
          ];
        });
        return navsListFromCategory;
      }
      case 'first_child_category': {
        let navsListFromFirstChildCategory = [];
        navsGroups.forEach((group) => {
          const { nodes } = group;
          navsListFromFirstChildCategory = [
            ...navsListFromFirstChildCategory,
            {
              totalCount: nodes.length,
              name: clearUrl(group.nodes[0].second_child_category),
              path: `/${clearUrl(group.nodes[0].category)}/${clearUrl(
                group.nodes[0].first_child_category
              )}/${clearUrl(group.nodes[0].second_child_category)}`,
            },
          ];
        });
        return navsListFromFirstChildCategory;
      }
      default:
        return [];
    }
  }
  return [];
};

export {
  shuffleArray,
  clearUrl,
  validateYouTubeUrl,
  youtubeParser,
  checkImageUrl,
  copyToClipboard,
  createContentQueries,
  generateRandomNumber,
  getDistincTags,
  getScrollbarHeight,
  getDeviceType,
  joinDateToNumberString,
  sortingPostsByDate,
  getMenuNavsListByLocation,
};
